import { LineInterface } from '../../models/line.interface';

export interface LinesInterfaceState {
  lines: Array<LineInterface>;
}

export const initialLinesState: LinesInterfaceState = {
  lines: null
};
